// Note: the following import should likely be moved to the new package
import { TDeviceInfo } from '../types'
import { getXboxInfoWebview2 } from './xbox/getXboxInfoWebview2'

export const getXboxNativeInfo = async (): Promise<TDeviceInfo> => {
  const info = await getXboxInfoWebview2()
  return {
    nativeVersion: info.appVersion,
    isLAT: info.isLAT,
    ...(info.advertisingId ? { advertisingId: info.advertisingId } : {}),
    deviceModel: info.deviceModel,
  }
}
